import { FirebaseHttpsCallableFactory } from '../types/firebase-functions';

export type FeaturebaseTokenResponse = { token: string };

export type GetFeaturebaseTokenOptions<TFunctions> = {
  functions: TFunctions;
  httpsCallable: FirebaseHttpsCallableFactory<TFunctions>;
};

export const getFeaturebaseToken = async <TFunctions>(
  options: GetFeaturebaseTokenOptions<TFunctions>,
): Promise<FeaturebaseTokenResponse> => {
  const { functions, httpsCallable } = options;
  const getToken = httpsCallable<void, FeaturebaseTokenResponse>(
    functions,
    'featurebaseSso-generateFeaturebaseSsoToken',
  );

  const { data } = await getToken();
  return data;
};
